import React, { useEffect } from 'react'
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts'

import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import LinearProgress from '@material-ui/core/LinearProgress'
import { red, blue } from '@material-ui/core/colors'

import { formatBrl } from '../../utils'
import useTypedSelector from '../../hooks/useTypedSelector'
import { useDispatch } from 'react-redux'
import { getResumeYear } from '../../store/transactions/transactionsActions'

export default function TransactionsResumeOverall() {
  const { resume, isLoading } = useTypedSelector(({ transactionsState }) => ({
    resume: transactionsState.resume,
    isLoading: transactionsState.loadingResume,
  }))

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getResumeYear())
  }, [dispatch])

  if (isLoading) {
    return <LinearProgress />
  }

  if (!resume) {
    return null
  }

  return (
    <>
      <Box display="flex" flex={1} marginY={1}>
        <Box display="flex" flex={1} alignItems="center" flexDirection="column">
          <Typography variant="caption">RECEITAS</Typography>
          <Typography variant="h5" style={{ color: blue[500] }}>
            {formatBrl(resume.incomes)}
          </Typography>
        </Box>
        <Box display="flex" flex={1} alignItems="center" flexDirection="column">
          <Typography variant="caption">DESPESAS</Typography>
          <Typography variant="h5" style={{ color: red[500] }}>
            {formatBrl(resume.expenses)}
          </Typography>
        </Box>
        <Box display="flex" flex={1} alignItems="center" flexDirection="column">
          <Typography variant="caption">SALDO</Typography>
          <Typography variant="h5">{formatBrl(resume.balance)}</Typography>
          {resume.balanceResources.map((item: any) => (
            <Typography key={item.name} variant="caption">
              {item.name}: {formatBrl(item.value)}
            </Typography>
          ))}
        </Box>
      </Box>
      <Box display="flex" flex={1} justifyContent="center" padding={4}>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart
            data={resume.total}
            style={{ fontFamily: '"Roboto", "Arial", "sans-serif"' }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              name="Receitas"
              dataKey="incomes"
              stroke={blue[500]}
              activeDot={{ r: 8 }}
            />
            <Line
              type="monotone"
              name="Despesas"
              dataKey="expenses"
              stroke={red[500]}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </>
  )
}
